import { render, staticRenderFns } from "./postlist.vue?vue&type=template&id=199dfb83&scoped=true&"
import script from "./postlist.vue?vue&type=script&lang=js&"
export * from "./postlist.vue?vue&type=script&lang=js&"
import style0 from "./postlist.vue?vue&type=style&index=0&id=199dfb83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199dfb83",
  null
  
)

export default component.exports